import { Favorite, FavoritePatch } from "@infoland/iprova-api";
import { namespace as favoriteNamespace } from "../modules/favorite/favorite";
import { Store } from "vuex";

/**
 * Temporary fix we should actually change the type in infoland/iprova-api
 */
export interface FavoritePost {
    /** The description of the favorite */
    description: string;
    /**  The id of the hyperlink*/
    hyperlink_id: string;
}

export class FavoriteStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /** Gets the current favorites */
    public get currentFavorites(): Favorite[] {
        return this.store.getters[`${favoriteNamespace}/currentFavorites`];
    }

    /** Loads the favorites */
    public async loadFavorites(): Promise<Favorite[]> {
        return this.store.dispatch(`${favoriteNamespace}/loadFavorites`);
    }
    /** Update the favorite */
    public async updateFavorite(favoriteId: number, favoritePatch: FavoritePatch): Promise<boolean | null> {
        return this.store.dispatch(`${favoriteNamespace}/updateFavorite`, { favoriteId, favoritePatch });
    }

    /** Delete the favorite by id */
    public async deleteFavorite(favoriteId: number): Promise<boolean | null> {
        return this.store.dispatch(`${favoriteNamespace}/deleteFavorite`, favoriteId);
    }

    /** Create a favorite */
    public async createFavorite(favoritePost: FavoritePost): Promise<boolean | null> {
        return this.store.dispatch(`${favoriteNamespace}/createFavorite`, favoritePost);
    }
}
